export default "__VITE_ASSET__BJtTJ8bN__"